
import { inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ProviderService } from '../Services/provider.service';
import { isPlatformServer } from '@angular/common';

export const cryptoResolverResolver: ResolveFn<any> = async (
  route,
  state
) =>  {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const _ProviderService = inject(ProviderService);
  let mkKey = makeStateKey<any>('cryptoResolver');
  const id = route.paramMap.get('id');
  console.log('id is ', id);
  if (id == null || id == undefined) {
    console.log('id is null');
    router.navigate(['/404']);
    return false;
  }
  return await  _ProviderService.getCryptoAddress(id)
};
